import GetShopOrderRequestModelBase from '../_generated/modelBases/get-shop-order-request-model-base';

export default class GetShopOrderRequestModel extends GetShopOrderRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
